module.exports = __webpack_public_path__ + "img/arrowgo2.af60776a.svg";